module.exports = __webpack_public_path__ + "assets/colibri-wp.525e0580.svg";